module.exports = __webpack_public_path__ + "img/left.4f5d443b.svg";